import {IRootState, RootState} from "../root-state.store";
import {ActivityStatus} from "../../common/enums";
import { IServiceBookService, ServiceBookService } from "../../services/serviceBook.service";
import { IServiceBook, ServiceBookDto } from "../../models/service-book/service-book.model";


export interface IServiceBookSearchParams {
  $limit?:number
  //$skip:number
  key?:string
  free?:boolean
  showDetails?:boolean
  block?:number
  number?:string
  $sort?: {
    number?: number;
    createdAt?:number;
    activatedAt?:number
    expireAt?:number
  }
}

export interface IPatchServiceBook {
  fk_apartment?:number
  name?: string,
  fk_apartment_type?: number,
  floor?: number,
  apartment_number?: string,
  type?: string,
  square_meter?: number,
  fk_apartment_block?: number
  address?: {
      name?:string,
      line1?: string,
      line2?: string,
      zip_code?: string,
      city?: string,
      country?: string,
      lng?: string,
      lat?: string
  }

}

export interface IServiceBookDetails {
  id?:number
  fk_apartment?:number
  activatedAt?:string|null
  address?:any|null
  apartment?:any|null
  createdAt?:string|null
  deletedAt?:string|null
  duration?:number
  expireAt?:string
  isExpired?:boolean
  number?:number
  owner?:any
  updatedAt?:string|null
  totalContacts:number
  totalDocuments:number
  totalEquipments:number
  totalMaintenances:number
  totalTickets:number
}

export interface IServiceBookState extends IRootState<IServiceBookService> {
  free:number
  used:number
  isLoading:boolean
  serviceBooks:IServiceBook[];
  serviceBookSearchParams:IServiceBookSearchParams
  currentServiceBook:IServiceBookDetails
  patchServiceBook:IPatchServiceBook
}

export class ServiceBookState extends RootState implements IServiceBookState {
  free:number
  used:number
  isLoading:boolean
  serviceBooks:IServiceBook[];
  serviceBookSearchParams:IServiceBookSearchParams
  currentServiceBook:IServiceBookDetails
  patchServiceBook:IPatchServiceBook

  constructor () {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new ServiceBookService
    this.free = 0
    this.used = 0
    this.isLoading = false
    this.serviceBooks = []
    this.serviceBookSearchParams = {
      $limit:12,
      free:false,
      showDetails:true,
      $sort:{number:1}
    }
    this.currentServiceBook = {
      totalContacts:0,
      totalDocuments:0,
      totalEquipments:0,
      totalMaintenances:0,
      totalTickets:0
    }
    this.patchServiceBook = {}
  }
}



// WEBPACK FOOTER //
// ./src/store/service-book/service-book-state.store.ts